import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=4cfce112&scoped=true&"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=4cfce112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfce112",
  null
  
)

export default component.exports